module.exports = __webpack_public_path__ + "static/media/location-maps-letter-g.0f6e073b.png";